import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { ProductoService } from '../../servicios/producto.service'
import { FormBuilder, Validators } from '@angular/forms';
import { MdcSnackbar } from '@angular-mdc/web';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ConfirmComponent } from 'src/app/confirm/confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalCarritoProductosComponent } from '../modal-carrito-productos/modal-carrito-productos.component';
import { ConfirmCancelCotizacionComponent } from 'src/app/confirm-cancel-cotizacion/confirm-cancel-cotizacion.component';

@Component({
  selector: 'app-cotizar',
  templateUrl: './cotizar.component.html',
  styleUrls: ['./cotizar.component.scss']
})
export class CotizarComponent implements OnInit {

	constructor(
		public globals: Globals,
		private fb: FormBuilder,
		private productoService: ProductoService,
		private snackBar: MdcSnackbar,
		private router: Router,
		private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,

	) { }

	formComportamiento = {
		enviando: false
	};

  cotizacion = {
    cargando: false
  }

	form = this.fb.group({
		nombre:[
			this.globals.configuracion.front.usuario.cotizacion_cliente_nombre,
			[
				Validators.required
			]
		],
		telefono_prefijo:[
			this.globals.configuracion.front.usuario.cotizacion_cliente_telefono_prefijo,
			[
				Validators.required
			]
		],
		telefono_numero:[
			this.globals.configuracion.front.usuario.cotizacion_cliente_telefono_numero,
			[
				Validators.required,
				Validators.pattern('[0-9]{7}')
			]
		],
	});

  formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  guardarCotizacion(){
    this.formComportamiento.enviando = true;

    this.productoService.cotizacionGuardar({
      cotizacion_cliente_id: this.globals.configuracion.front.usuario.cotizacion_cliente_id,

      nombre: this.form.controls.nombre.value,
      telefono_prefijo: this.form.controls.telefono_prefijo.value,
      telefono_numero: this.form.controls.telefono_numero.value,

      cotizacion_id: this.globals.configuracion.front.cart.cotizacion_id,
      typeabbrev: this.globals.configuracion.front.typeabbrev,
      vendedor: this.globals.configuracion.front.vendedor,
      
      productos: this.globals.configuracion.front.cart.productos
    }).subscribe(
      resultado =>{
        if( !resultado.error ){
          if( this.globals.configuracion.front.cart.cotizacion_id == "" ){
            this.snackBar.open(`Cotización enviada`, ' ', {
              dismiss: true
            });

            this.globals.configuracion.front.usuario = resultado.dataToken.usuario;
          }else{
            this.snackBar.open(`Cotización guardada`, ' ', {
              dismiss: true
            });
          }

          this.globals.setDataToken( resultado.dataToken );

          this.globals.configuracion.front.cart.cotizacion_id = "";
          this.globals.configuracion.front.cart.productos.splice( 0 );

          this.globals.configuracion.front.cart.total = this.formatter.format( 0 );

          this.globals.setDataFront();

          if( this.globals.configuracion.front.usuario.cotizacion_cliente_id != '' ){
            this.router.navigate(['/cotizaciones']);
          }else{
            this.router.navigate(['/']);
          }
        }else{
          this.snackBar.open(resultado.mensaje, ' ', {
            dismiss: true
          });
        }

        this.formComportamiento.enviando = false;
      },
      error =>{
        this.snackBar.open(`Error de conexión. Vuelva a intentarlo`, ' ', {
          dismiss: true
        });

        this.formComportamiento.enviando = false;
      }
    )
  }

  cancelarCotizacion(){
    const dialogRef = this.dialog.open(ConfirmCancelCotizacionComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // El usuario confirmó, ejecuta la acción
        this.globals.configuracion.front.cart.cotizacion_id = "";
        this.globals.configuracion.front.cart.productos.splice( 0 );

        this.globals.configuracion.front.cart.total = this.formatter.format( 0 );

        this.globals.setDataFront();
      } else {
        
      }
    })
    
  }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(params => {
      if (params.cotizacion_id != null) {
        this.cotizacion.cargando = true;

        this.productoService.cotizacionCarrito({
          cotizacion_id: params.cotizacion_id,
        }).subscribe(
          resultado =>{
            if( !resultado.error ){
              this.globals.setDataToken( resultado.dataToken );

              this.globals.configuracion.front.usuario = resultado.dataToken.usuario;
              this.globals.configuracion.front.cart.cotizacion_id = resultado.cotizacion.cotizacion_id;
              this.globals.configuracion.front.typeabbrev = resultado.cotizacion.typeabbrev;

              this.globals.configuracion.front.cart.productos = resultado.dataToken.app.cart.productos;

              var total = 0;
              for( let x = 0; x < this.globals.configuracion.front.cart.productos.length; x++ ){
                total += this.globals.configuracion.front.cart.productos[x].precio_final_con_impuesto * this.globals.configuracion.front.cart.productos[x].cantidad;
              }
              
              this.globals.configuracion.front.cart.total = this.formatter.format( total );

              this.globals.setDataFront();
            }else{
              this.snackBar.open(resultado.mensaje, ' ', {
                dismiss: true
              });
            }

            this.cotizacion.cargando = false;
          },
          error =>{
            this.snackBar.open(`Error de conexión. Vuelva a intentarlo`, ' ', {
              dismiss: true
            });

            this.cotizacion.cargando = false;
          }
        )
      }
    })
  
  }

}
